import { useEffect, useState } from 'react';
import './App.css';
import Topbar from './NavBar/Topbar';
import Mainpost from './Mainpage/Mainpost';
import { Routes, Route } from 'react-router-dom';
import WritePost from './WritePost/Writepost';
import Edit from './WritePost/Edit';
import Postdetail from './Post/Postdetail';
import Login from './Login/Login';
import Register from './Login/Register';
import LocalsPost from './Mainpage/LocalsPost';
import UnLogMain from './Mainpage/UnLogMain2';


function App() {


    // 현재 포스트 목록
    //  현재 블로그 이름
  const [blogName, setBlogName ] = useState('Short Blog')
  const [check, setCheck] = useState()

  let getLogin = sessionStorage.getItem('login')

  useEffect( ()=> {
    setCheck(getLogin)
  },[])


  return (
    <div>
         {/* { getLogin ? <Iflogin></Iflogin> : <IfNologin></IfNologin>   */}

         <Iflogin></Iflogin>
    </div>
  );
}

function Iflogin() {

  
  const [blogName, setBlogName ] = useState('Short Blog')
  console.log(localStorage.getItem('writed'))

  
  return(
    <div>
      <Topbar blogName={blogName}></Topbar>       
      <Routes>
        <Route path='/' element={<Mainpost></Mainpost>}></Route>
        <Route path='/write' element={<WritePost></WritePost>}></Route>
        <Route path='/edit' element={<Edit></Edit>}></Route>
        <Route path='/detail/:id' element={<Postdetail></Postdetail>}></Route>
        <Route path='/login' element={<Login></Login>}></Route>
        <Route path='/register' element={<Register></Register>}></Route>
        <Route path='/locals' element={<LocalsPost></LocalsPost>}></Route>
        <Route path='*' element={<div>존재하지 않는 페이지입니다.</div>}></Route>
      </Routes>

    </div>
  )
}

function IfNologin() {
  const [blogName, setBlogName ] = useState('Short Blog')
  return(
    <div>
      <Topbar blogName={blogName}></Topbar>       
      <Routes>
        <Route path='/' element={<UnLogMain></UnLogMain>}></Route>
        <Route path='/write' element={<WritePost></WritePost>}></Route>
        <Route path='/edit' element={<Edit></Edit>}></Route>
        <Route path='/detail/:id' element={<Postdetail></Postdetail>}></Route>
        <Route path='/login' element={<Login></Login>}></Route>
        <Route path='/Register' element={<Register></Register>}></Route>
        <Route path='/locals' element={<LocalsPost></LocalsPost>}></Route>
        <Route path='*' element={<div>존재하지 않는 페이지입니다.</div>}></Route>
      </Routes>

    </div>
  )
}

export default App;
